import { render, staticRenderFns } from "./WorklistDetails.vue?vue&type=template&id=59858c35&"
import script from "./WorklistDetails.vue?vue&type=script&lang=js&"
export * from "./WorklistDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports